import { ENV } from '../../envUtils';

/**
 * Endpoint path builders for note CRUD operations on AIM entities.
 *
 * Each property is a function that returns a URL path string built from ENV and the target entity's aimId combined with the appropriate resource segment.
 */
export const notesEndpoints = {
  notes: (aimId: number) => `${ENV}/notes/${aimId}`,
  noteDetails: (aimId: number, noteId: number) => `${ENV}/notes/${aimId}/note/${noteId}`,
  newNote: (aimId: number) => `${ENV}/notes/${aimId}/note/new`,
  updateNote: (aimId: number, noteId: number) => `${ENV}/notes/${aimId}/note/${noteId}/edit`,
  deleteNote: (aimId: number, noteId: number) => `${ENV}/notes/${aimId}/note/${noteId}/delete`
};
